import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppConfig } from '../config/app.config';
import { SponsorInfo } from '../../store/models/ui.state';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class SponsorService {
  private config = inject(AppConfig);
  private http = inject(HttpClient);

  getCurrentSponsor(): Observable<SponsorInfo> {
    return this.http.get<SponsorInfo>(`${this.config.buildUri('sponsor')}/CurrentSponsor`);
  }
}
